module.exports = __webpack_public_path__ + "static/media/ins.7112d0eb.png";